import styled from 'styled-components';
import {constants} from '../../constants';


/*

Props:
• 

*/

export const StyledToolbar = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: #4AC4D1;
	padding-top: 12px;
	padding-bottom: 15px;

`;


// WEBPACK FOOTER //
// ./src/js/components/ToolbarSearch/StyledToolbar.jsx